import { api } from './api'

export interface AmendmentDetectionSettings {
  process_new_bills: boolean
  process_version_changes: boolean
  // PDF processing settings
  dpi: number
  images_per_page: number
}

export interface SessionSettings {
  sync_enabled: boolean
  amendment_detection: AmendmentDetectionSettings
}

export interface DataSourceSyncSettings {
  sessions: {
    [session: string]: SessionSettings
  }
}

export interface GlobalSessionSyncSettings {
  maryland?: DataSourceSyncSettings
  federal?: DataSourceSyncSettings
}

export interface SyncSettings {
  // Data-source-first sync settings structure
  session_sync: GlobalSessionSyncSettings
  updated_at?: string
  updated_by?: string
}

export interface DebugSettings {
  enabled: boolean
  updated_at?: string
  updated_by?: string
}

// Backend now returns snake_case only - no transformation needed

export const adminSettingsApi = {
  // Debug settings
  getDebugSettings: async (): Promise<DebugSettings> => {
    console.log('🔍 Fetching debug settings')
    const response = await api.get<DebugSettings>('/settings/debug', {
      is_global: true
    })
    console.log('✅ Fetched debug settings:', response.data)
    return response.data
  },

  updateDebugSettings: async (enabled: boolean): Promise<DebugSettings> => {
    console.log(`🔄 Updating debug settings: ${enabled}`)
    const response = await api.post<DebugSettings>(`/settings/debug?enabled=${enabled}`, null, {
      is_global: true
    })
    console.log('✅ Updated debug settings:', response.data)
    return response.data
  },

  // Sync settings
  getSyncSettings: async (): Promise<SyncSettings> => {
    console.log('🔍 Fetching sync settings')
    const response = await api.get<SyncSettings>('/settings/sync', {
      is_global: true
    })
    console.log('✅ Fetched sync settings:', response.data)
    return response.data
  },

  updateSyncSettings: async (settings: {
    session_sync: GlobalSessionSyncSettings
  }): Promise<SyncSettings> => {
    console.log('🔄 Updating sync settings:', settings)
    const response = await api.post<SyncSettings>('/settings/sync', settings, {
      is_global: true
    })
    console.log('✅ Updated sync settings:', response.data)
    return response.data
  }
}